<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update'
  },
  props: {
    value: {
      type: [Array, Number, String, Object],
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    labelSize: {
      type: Number,
      default: null
    },
    accept: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    iconClass: {
      type: String,
      default: 'image'
    }
  },
  data() {
    return {
      temp: '',
      dialog: {
        visible: false
      },
      rootCategories: [],
      categoriesTree: [],
      viewSetting: 'list',
      searchText: '',
      contentLoading: false,
      breadcrumb: [],
      teachers: [],
      category: null,
      treeProps: {
        children: 'childs',
        label: 'name',
        isLeaf: 'isLeaf'
      },
      selected: null
    }
  },
  watch: {
    value: {
      handler(val) {
        this.temp = val
      },
      immediate: true
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('update', value)
    },
    handleSelectDocument() {
      this.temp = this.selected
      this.$emit('selected', this.selected)
      this.dialog.visible = false
    },
    async handleOpenDocumentDialog() {
      this.dialog.visible = true
      this.rootCategories = await this.getCategories()
    },
    handleSelectCategoryOrFile(item) {
      this.$refs['document-table'].setCurrentRow()
      this.selected = item
    },

    goToPermission() {
      this.$router.push({
        name: 'Document-Permissions'
      })
    },

    isSchoolAdmin() {
      return (
        this.profile.roles &&
        (this.profile.roles.includes('super_admin') ||
          this.profile.roles.includes('admin') ||
          this.profile.roles.includes('group_chief') ||
          this.profile.roles.includes('department_chief'))
      )
    },

    collapseTree() {
      // this.$refs.tree.setCurrentNode()
    },

    async quickShareFile(item) {
      const data = await this.$store.dispatch('document/QuickShareFile', {
        fileId: item._id
      })
      const link = data.link
      window.open(link, '__blank')
    },

    async handleSelectCategory(node) {
      this.contentLoading = true
      this.selected = null
      const data = await this.getCategory({
        categoryId: node._id
      })

      const temp = data.category

      Object.assign(temp, {
        childs: []
      })

      temp.files.forEach((file) => {
        temp.childs.push(
          Object.assign(file, {
            type: 'file',
            author: file.fileInfo.author,
            price: file.fileInfo.price,
            source: file.fileInfo.source,
            thumbnailUrl: file.fileInfo.thumbnailUrl,
            size: file.fileSize || 0
          })
        )
      })

      this.category = temp
      this.breadcrumb = data.category.parents || []
      this.contentLoading = false
    },
    loadTree(node, resolve) {
      if (node.level === 0) {
        return resolve(this.rootCategories)
      }

      this.getCategories({
        parentId: node.data._id
      }).then((data) => {
        resolve(data)
      })
    },
    async getCategory(query) {
      const data = await this.$store.dispatch('document/GetCategory', query)
      return data
    },
    async getCategories(query) {
      const data = await this.$store.dispatch('document/GetCategories', query)
      return data.categories
    }
  }
}
</script>

<template>
  <div class="base-input-document-file">
    <md-field
      style="position: relative; width: 100%; display: flex; flex-wrap: wrap"
    >
      <div
        v-if="label"
        class="input-label"
        style="text-align: left; margin-bottom: 8px; width: 100%"
      >
        <label
          style="color: #333; font-weight: bold; position: relative"
          :style="'font-size: ' + (labelSize ? labelSize : 14) + 'px'"
        >
          {{ label }}
        </label>
      </div>

      <el-input
        :disabled="disabled"
        :value="temp ? temp.name || temp : ''"
        v-on="$listeners"
        v-loading="loading"
        @change="handleChange"
        @focus="handleOpenDocumentDialog"
      >
        <el-button
          v-if="!disabled"
          slot="prepend"
          @click="handleOpenDocumentDialog"
        >
          <svg-icon v-if="iconClass" :iconClass="iconClass" />
        </el-button>
        <!-- <el-button v-if="!disabled" slot="append" @click.native="$emit('clear', $event)">
          <md-icon>close</md-icon>
        </el-button> -->
      </el-input>
    </md-field>

    <el-dialog
      :visible.sync="dialog.visible"
      :fullscreen="true"
      :title="$t('SELECT_DOCUMENT')"
      append-to-body
      class="document-dialog"
    >
      <!-- <md-dialog-title>
        <div class="title">Chọn bài giao</div>
        <md-button
          class="md-icon-button"
          @click.prevent="dialog.visible = false"
        >
          <md-icon>close</md-icon>
        </md-button>
      </md-dialog-title> -->
      <div>
        <div class="main-panel md-layout">
          <div
            class="categories-panel md-layout-item md-size-25 md-small-size-30 full-height"
          >
            <div class="shortcut">
              <span class="btn" @click="collapseTree">THU GỌN</span>
            </div>
            <div v-if="rootCategories.length > 0" class="categories-tree">
              <el-tree
                ref="tree"
                lazy
                :load="loadTree"
                :props="treeProps"
                node-key="_id"
                @node-click="handleSelectCategory"
              >
                <span class="custom-tree-node" slot-scope="{ node }">
                  <i
                    class="md-svg-loader md-icon md-icon-image md-theme-default"
                  >
                    <svg
                      width="22"
                      height="19"
                      viewBox="0 0 22 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.5"
                        d="M10.9886 18.9958C8.55304 18.9958 6.11648 18.9958 3.68087 18.9958C2.82901 19.0018 2.00188 18.7109 1.34264 18.1735C0.683394 17.636 0.233547 16.8858 0.071019 16.0529C0.0265247 15.8368 0.00382394 15.6168 0.00320836 15.3963C-0.00106945 11.4863 -0.00106945 7.57664 0.00320836 3.66728C-0.00363893 2.81842 0.289074 1.99415 0.830252 1.33841C1.37143 0.682674 2.12666 0.237148 2.96405 0.0796422C3.22636 0.0305344 3.49288 0.00699029 3.75976 0.0093358C5.07336 0.00294396 6.38689 -0.00801347 7.7014 0.0093358C8.37821 -0.00335655 9.04486 0.174922 9.62427 0.523606C10.2037 0.872291 10.6722 1.37714 10.9758 1.97984C11.105 2.21268 11.2242 2.45101 11.3342 2.69299C11.3641 2.7707 11.4192 2.83622 11.4909 2.87908C11.5625 2.92194 11.6464 2.93969 11.7293 2.92949C13.9055 2.92401 16.0816 2.92401 18.2578 2.92949C18.7518 2.91828 19.2429 3.00683 19.7015 3.18984C20.1602 3.37286 20.5769 3.64654 20.9265 3.99434C21.2761 4.34215 21.5513 4.75689 21.7356 5.21354C21.9199 5.6702 22.0095 6.1593 21.9988 6.65135C21.9988 9.51916 21.9988 12.387 21.9988 15.2548C22.0115 15.7507 21.9226 16.244 21.7375 16.7046C21.5525 17.1652 21.2752 17.5834 20.9226 17.9337C20.57 18.284 20.1494 18.5591 19.6865 18.7422C19.2237 18.9252 18.7281 19.0125 18.2303 18.9986C15.8176 18.9986 13.4038 18.9986 10.9886 18.9986V18.9958ZM15.4959 13.8824C15.9689 13.8824 16.4428 13.8824 16.9158 13.8824C17.0155 13.8878 17.1152 13.873 17.2089 13.8387C17.3026 13.8045 17.3882 13.7515 17.4607 13.6831C17.5331 13.6148 17.5907 13.5324 17.6301 13.441C17.6694 13.3497 17.6896 13.2513 17.6895 13.1519C17.6896 13.0528 17.6695 12.9547 17.6304 12.8636C17.5913 12.7725 17.5339 12.6903 17.4619 12.622C17.3899 12.5536 17.3047 12.5006 17.2115 12.4661C17.1182 12.4316 17.0189 12.4164 16.9195 12.4214C15.9729 12.4214 15.0257 12.4214 14.0778 12.4214C13.9764 12.4139 13.8745 12.4275 13.7786 12.4614C13.6827 12.4952 13.595 12.5486 13.5209 12.6181C13.4469 12.6876 13.3881 12.7716 13.3484 12.8649C13.3087 12.9582 13.289 13.0588 13.2904 13.1601C13.2925 13.2593 13.3145 13.3571 13.3554 13.4476C13.3963 13.5381 13.4551 13.6194 13.5283 13.6868C13.6015 13.7541 13.6875 13.8061 13.7813 13.8395C13.8751 13.873 13.9747 13.8872 14.0741 13.8814C14.549 13.8887 15.0229 13.8824 15.4959 13.8824Z"
                        fill="black"
                      />
                    </svg>
                  </i>
                  <span class="node-label">{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
          <div
            v-loading="contentLoading"
            class="content-panel md-layout-item md-size-75 md-small-size-70 full-height"
          >
            <md-empty-state
              v-if="!category"
              md-icon="book"
              md-label="Chưa chọn danh mục nào"
              md-description="Vui lòng lựa chọn danh mục để hiển thị tài liệu."
            >
            </md-empty-state>
            <div
              v-else
              class="main-content"
              :class="selected ? 'selected-content' : ''"
            >
              <div class="breadcrumb">
                <span v-for="item in breadcrumb" :key="item._id" class="item">
                  <span class="label">{{ item.name }}</span>
                  <md-icon>chevron_right</md-icon>
                </span>
                <span class="item">
                  <span class="label">{{ category.name }}</span>
                </span>
              </div>

              <div class="documents">
                <el-table
                  style="width: 100%; margin-top: 24px"
                  :data="category.childs"
                  highlight-current-row
                  ref="document-table"
                  @current-change="handleSelectCategoryOrFile"
                >
                  <el-table-column
                    label=""
                    prop="fileInfo.thumbnailUrl"
                    align="center"
                    width="100"
                  >
                    <template slot-scope="scope">
                      <img
                        v-if="
                          scope.row.fileInfo && scope.row.fileInfo.thumbnailUrl
                        "
                        :src="scope.row.fileInfo.thumbnailUrl | media"
                        style="max-width: 62px; max-height: 100px"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('NAME')"
                    prop="name"
                    style="font-weight: bold"
                  />
                  <el-table-column
                    :label="$t('AUTHOR')"
                    prop="author"
                    align="center"
                  />
                  <el-table-column
                    :label="$t('SIZE')"
                    prop="size"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.size | memorySize }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="selected" class="category-drawler">
                <div class="draler-content">
                  <div class="title">
                    <i
                      v-if="selected.type === 'category'"
                      class="md-svg-loader md-icon md-icon-image md-theme-default"
                    >
                      <svg
                        width="22"
                        height="19"
                        viewBox="0 0 22 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.5"
                          d="M10.9886 18.9958C8.55304 18.9958 6.11648 18.9958 3.68087 18.9958C2.82901 19.0018 2.00188 18.7109 1.34264 18.1735C0.683394 17.636 0.233547 16.8858 0.071019 16.0529C0.0265247 15.8368 0.00382394 15.6168 0.00320836 15.3963C-0.00106945 11.4863 -0.00106945 7.57664 0.00320836 3.66728C-0.00363893 2.81842 0.289074 1.99415 0.830252 1.33841C1.37143 0.682674 2.12666 0.237148 2.96405 0.0796422C3.22636 0.0305344 3.49288 0.00699029 3.75976 0.0093358C5.07336 0.00294396 6.38689 -0.00801347 7.7014 0.0093358C8.37821 -0.00335655 9.04486 0.174922 9.62427 0.523606C10.2037 0.872291 10.6722 1.37714 10.9758 1.97984C11.105 2.21268 11.2242 2.45101 11.3342 2.69299C11.3641 2.7707 11.4192 2.83622 11.4909 2.87908C11.5625 2.92194 11.6464 2.93969 11.7293 2.92949C13.9055 2.92401 16.0816 2.92401 18.2578 2.92949C18.7518 2.91828 19.2429 3.00683 19.7015 3.18984C20.1602 3.37286 20.5769 3.64654 20.9265 3.99434C21.2761 4.34215 21.5513 4.75689 21.7356 5.21354C21.9199 5.6702 22.0095 6.1593 21.9988 6.65135C21.9988 9.51916 21.9988 12.387 21.9988 15.2548C22.0115 15.7507 21.9226 16.244 21.7375 16.7046C21.5525 17.1652 21.2752 17.5834 20.9226 17.9337C20.57 18.284 20.1494 18.5591 19.6865 18.7422C19.2237 18.9252 18.7281 19.0125 18.2303 18.9986C15.8176 18.9986 13.4038 18.9986 10.9886 18.9986V18.9958ZM15.4959 13.8824C15.9689 13.8824 16.4428 13.8824 16.9158 13.8824C17.0155 13.8878 17.1152 13.873 17.2089 13.8387C17.3026 13.8045 17.3882 13.7515 17.4607 13.6831C17.5331 13.6148 17.5907 13.5324 17.6301 13.441C17.6694 13.3497 17.6896 13.2513 17.6895 13.1519C17.6896 13.0528 17.6695 12.9547 17.6304 12.8636C17.5913 12.7725 17.5339 12.6903 17.4619 12.622C17.3899 12.5536 17.3047 12.5006 17.2115 12.4661C17.1182 12.4316 17.0189 12.4164 16.9195 12.4214C15.9729 12.4214 15.0257 12.4214 14.0778 12.4214C13.9764 12.4139 13.8745 12.4275 13.7786 12.4614C13.6827 12.4952 13.595 12.5486 13.5209 12.6181C13.4469 12.6876 13.3881 12.7716 13.3484 12.8649C13.3087 12.9582 13.289 13.0588 13.2904 13.1601C13.2925 13.2593 13.3145 13.3571 13.3554 13.4476C13.3963 13.5381 13.4551 13.6194 13.5283 13.6868C13.6015 13.7541 13.6875 13.8061 13.7813 13.8395C13.8751 13.873 13.9747 13.8872 14.0741 13.8814C14.549 13.8887 15.0229 13.8824 15.4959 13.8824Z"
                          fill="black"
                        />
                      </svg>
                    </i>

                    <md-icon v-else>description</md-icon>

                    <div class="label" style="padding-left: 12px">
                      {{ selected.name }}
                    </div>
                  </div>

                  <div class="thumbnail">
                    <div class="box">
                      <img :src="selected.thumbnailUrl | media" />
                    </div>
                  </div>

                  <div class="hr"></div>

                  <div class="info">
                    <div class="info-item">
                      <div class="label">{{ $t('TYPE') }}</div>
                      <div class="detail">
                        {{
                          selected.type === 'category'
                            ? $t('FOLDER')
                            : $t('FILE')
                        }}
                      </div>
                    </div>
                    <div class="info-item">
                      <div class="label">{{ $t('AUTHOR') }}</div>
                      <div class="detail">{{ selected.author || '-' }}</div>
                    </div>
                    <div class="info-item">
                      <div class="label">{{ $t('CREATED_AT') }}</div>
                      <div class="detail">{{ selected.createdAt | dateF }}</div>
                    </div>
                    <div class="info-item">
                      <div class="label">{{ $t('SIZE') }}</div>
                      <div class="detail">{{ selected.size | memorySize }}</div>
                    </div>
                  </div>

                  <div class="buy-btn">
                    <BaseButton
                      class="cancel-btn"
                      :label="$t('CANCEL')"
                      icon="cancel"
                      @click="handleSelectCategoryOrFile(null)"
                    />
                    <BaseButton
                      class="select-btn"
                      :label="$t('SELECT')"
                      icon="check"
                      @click="handleSelectDocument"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss">
.document-dialog {
  width: 100%;
  height: 100%;
  // position: relative;

  .md-dialog-title {
    display: flex;
    justify-content: space-between;
    margin: 0 !important;
    height: 100px;
    align-items: center;
  }
  .md-dialog-container {
    // max-width: 100%;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    max-height: 100%;
    max-width: 100%;
  }

  .md-dialog-content {
    padding: 0;
    height: calc(100% - 100px);
  }

  .main-panel {
    height: calc(100%);
    .quick-access-panel {
      background: #fff;
      height: calc(100%);
      border-right: 1px solid rgba(0, 0, 0, 0.2);
      padding-top: 42px;

      .item {
        height: 40px;
        cursor: pointer;
        display: flex;
        align-items: center;
        padding-left: 32px;
      }

      .item:hover {
        background: #e6fbea;
      }
    }

    .categories-panel {
      background: #fff;
      height: calc(100%);
      overflow-y: auto;
      .shortcut {
        height: 62px;
        display: flex;
        padding-top: 10px;
        padding-left: 20px;
        padding-right: 20px;
        justify-content: space-between;
        align-items: center;
        .btn {
          cursor: pointer;
          margin: 6px;
          font-weight: bold;
          color: #1cab36;
        }

        .btn-box {
          background-color: #1cab36;
          padding: 6px 8px;
          color: white;
          font-weight: bold;
          // border-radius: 6px;
          cursor: pointer;
        }
      }

      .el-tree-node__content {
        height: 40px;
      }

      .custom-tree-node {
        display: flex;
        align-items: center;
        height: 40px;
        .node-label {
          padding-left: 14px;
        }
      }
    }

    .content-panel {
      overflow-y: auto;
      overflow-x: hidden;
      height: calc(100%);
      padding: 14px 32px;
      .breadcrumb {
        width: 100%;
        display: flex;
        .item {
          display: flex;
          align-items: center;
          .label {
            font-size: 18px;
            font-weight: bold;
            padding-right: 8px;
          }
          padding-right: 8px;
        }
      }

      .file-modules {
        margin: 20px 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;

        .selected-card {
          background: #e6fbea !important;
          color: #1cab36 !important;
          .md-card-media {
            background: #fff !important;
          }
        }

        .md-card {
          margin: 12px;
          width: 180px;
          cursor: pointer;

          .md-card-media {
            height: 270px;
          }
          .md-card-header {
            padding: 8px;
          }
          .md-title {
            font-size: 14px;
            font-weight: bold;
            text-align: left;
            line-height: 18px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .md-subhead {
            font-size: 12px;
            text-align: left;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .md-card-actions {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .md-icon {
              font-size: 12px;
              cursor: pointer;
            }
          }
        }
      }

      .main-content.selected-content > .documents {
        width: calc(100% - 300px);
      }

      .main-content {
        height: 100%;
        position: relative;
        width: 100%;
        .category-drawler {
          width: 300px;
          height: calc(100%);
          background: #fff;
          position: absolute;
          top: 0;
          right: 0;
          padding: 24px 12px;
          overflow: hidden;

          .draler-content {
            position: relative;
            height: calc(100%);

            .md-icon {
              margin: 0;
            }

            .title {
              font-weight: bold;
              font-size: 18px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              width: 100%;
            }

            .thumbnail {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 24px 0;

              img {
                max-height: 200px;
                max-width: 134px;
              }
            }

            .hr {
              width: calc(100% - 48px);
              margin: 12px 24px;
              border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            }

            .info {
              .info-item {
                padding: 4px 0;
                width: 100%;
                display: flex;
                .label {
                  color: rgba(0, 0, 0, 0.5);
                  width: 100px;
                  text-align: left;
                  padding-left: 10px;
                }

                .detail {
                  width: 200px;
                  text-align: left;
                  padding-right: 10px;
                }
              }
            }

            .buy-btn {
              .select-btn,
              .cancel-btn {
                width: 40%;
                margin: 0;
                position: absolute;
                bottom: 42px;
                right: 0;
              }

              .cancel-btn {
                left: 0;
                button {
                  background: #fff !important;
                  color: #000 !important;
                }
              }
            }
          }
        }
      }
    }
  }
}

.base-input-document-file {
  .input-label label {
    left: initial;
    top: initial;
  }

  .md-field {
    padding: 0 !important;
  }

  .el-input {
    // background-color: #fff !important;
    box-shadow: 0 8px 20px rgba($color: #000000, $alpha: 0.16) !important;
    border: 1px solid transparent !important;
    margin: 0 !important;
    width: 100% !important;
    height: 42px !important;
  }

  .el-input__inner {
    padding: 0 6px;
    border: none;
  }

  .el-input-group__prepend,
  .el-input-group__append {
    // border: 1px solid transparent !important;
    background: #fff !important;
    border: none !important;
    padding: 0 10px;

    .svg-icon {
      width: 32px;
      height: 32px;
    }
  }

  input {
    height: 42px !important;
  }
  .md-field:after {
    height: 0 !important;
  }
  .md-field:before {
    height: 0 !important;
  }
}
@media only screen and (max-width: 320px) {
}
@media only screen and (max-width: 480px) {
}
@media only screen and (max-width: 600px) {
}
@media only screen and (max-width: 768px) {
}
@media only screen and (max-width: 900px) {
}
@media only screen and (max-width: 1024px) {
}
</style>
